export default __webpack_public_path__ + "static/media/vehicleInsurance.b29bf8ad.svg";